// get_badge
export const GET_BADGE = 'get_badge';
export const GET_BADGE_SUCCESSFUL = 'get_badge_successfull';
export const GET_BADGE_FAILED = 'get_badge_failed';

// create_badge
export const CREATE_BADGE = 'create_badge';
export const CREATE_BADGE_SUCCESSFUL = 'create_badge_successfull';
export const CREATE_BADGE_FAILED = 'create_badge_failed';

// update_badge
export const UPDATE_BADGE = 'update_badge';
export const UPDATE_BADGE_SUCCESSFUL = 'update_badge_successfull';
export const UPDATE_BADGE_FAILED = 'update_badge_failed';

// delete_badge
export const DELETE_BADGE = 'delete_badge';
export const DELETE_BADGE_SUCCESSFUL = 'delete_badge_successfull';
export const DELETE_BADGE_FAILED = 'delete_badge_failed';
